module.exports = __webpack_public_path__ + "img/3314b45.jpg";